import 'css-chunksrc/client/scenes/projectResourceEdition/infoResource/styles.scss';export default {
  "dataUser": "_dataUser_1c3dc_1",
  "profession": "_profession_1c3dc_9",
  "avatar": "_avatar_1c3dc_15",
  "name": "_name_1c3dc_25",
  "email": "_email_1c3dc_31"
};